import React from "react";
import { DOC_CENTER } from "@/constants/testIds";

const OUTCOMES = [
  { slug: "find-instantly", title: "Find Documents Instantly", desc: "Search any document by shipment, supplier or PO in milliseconds — no folders, no inbox archaeology." },
  { slug: "latest-version", title: "Always The Latest Version", desc: "Every team member references the same approved version. Old PDFs never circulate again." },
  { slug: "shipment-organization", title: "Shipment-Based Organization", desc: "Documents live where the operation lives — connected to the shipment, not the file system." },
  { slug: "less-email", title: "Less Email Searching", desc: "Cut hours of forwarding, replying and scrolling. The workspace replaces the inbox." },
  { slug: "team-collaboration", title: "Better Team Collaboration", desc: "Procurement, logistics and finance share one operational record — with permission boundaries." },
  { slug: "complete-visibility", title: "Complete Visibility", desc: "Audit every document, every revision and every approval for every shipment, instantly." },
];

export default function BusinessOutcomes() {
  return (
    <section data-testid={DOC_CENTER.outcomes.section} className="relative py-28 md:py-36">
      <div className="dc-container">
        <div className="max-w-2xl">
          <span className="dc-eyebrow">Business outcomes</span>
          <h2 className="mt-4 font-display text-4xl font-black leading-[1.05] tracking-tighter text-ink-950 sm:text-5xl md:text-[56px]">
            What changes the day you<br />switch the workspace on.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[color:var(--dc-border)] bg-[color:var(--dc-border)] md:grid-cols-2 lg:grid-cols-3">
          {OUTCOMES.map((o, i) => (
            <article
              key={o.slug}
              data-testid={DOC_CENTER.outcomes.card(o.slug)}
              className="group bg-white p-7 transition-colors duration-200 hover:bg-[color:var(--dc-bg)]"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-[12px] uppercase tracking-[0.18em] text-ink-400">
                  0{i + 1}
                </span>
                <span className="h-1 w-8 bg-ink-200 transition-colors group-hover:bg-ink-950" />
              </div>
              <h3 className="mt-8 font-display text-2xl font-extrabold tracking-tight text-ink-950">
                {o.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-ink-600">{o.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
